'use strict';

var defaultNewDate = require('../internal/defaultNewDate');

var DATE_OPTIONS = {
  'newDateInternal': defaultNewDate
};

module.exports = DATE_OPTIONS;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar/date/var/DATE_OPTIONS.js
// module id = 905
// module chunks = 1